// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/collapsible.scss';
import React, { useEffect, useRef, useState } from 'react';
import { SvgIconType } from '../SvgIcon/SvgIconType';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { Size, Spacing } from '@front/sharedcomponents/Variables';
import { Stack } from '../Stack/Stack';
export const Collapsible = ({ title, children, initialOpen = false, className, buttonClassName, onOpened }) => {
    const [isOpen, setIsOpen] = useState(initialOpen);
    const contentRef = useRef(null);
    useEffect(() => {
        if (!contentRef.current)
            return;
        if (isOpen) {
            contentRef.current.removeAttribute('inert');
        }
        else {
            contentRef.current.setAttribute('inert', '');
        }
    }, [isOpen]);
    const containerClassNames = ['collapsible', className];
    const containerClassName = containerClassNames.filter(Boolean).join(' ');
    const btnClassNames = ['collapsible-button', buttonClassName, isOpen ? 'expanded' : 'collapsed'];
    const btnClassName = btnClassNames.filter(Boolean).join(' ');
    const handleTransitionEnd = (e) => {
        if (e.target !== e.currentTarget)
            return;
        if (isOpen)
            onOpened === null || onOpened === void 0 ? void 0 : onOpened();
    };
    return (React.createElement(Stack, { className: containerClassName, direction: "column", spacing: Spacing.None },
        React.createElement("button", { className: btnClassName, onClick: () => setIsOpen(!isOpen) },
            React.createElement(Typography, { level: TypographyLevel.BodySm, noWrap: true }, title),
            React.createElement("div", { className: "collapsible-button-icon" },
                React.createElement(SvgIcon, { icon: isOpen ? SvgIconType.ArrowDown : SvgIconType.ArrowRight, size: Size.None }))),
        React.createElement("div", { ref: contentRef, className: `collapsible-content ${isOpen ? 'open' : ''}`, onTransitionEnd: handleTransitionEnd },
            React.createElement("div", { className: "collapsible-content-inner" }, children))));
};
